<template>
  <SiruiSearch
    ref="baseInfoFormRef"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
    @changeMethod="changeMethod"
    :isDisabledForm="isDisabledForm"
  >
  </SiruiSearch>
</template>

<script>
  import { baseFormColumn, baseFormRules } from './index.js';
  import BASE_API from '@/api/dataBase';
  export default {
    name: 'BaseInfoForm',
    props: {
      isDisabledForm: {
        type: Boolean,
        default: false,
      },
      // 网络获取数据反填
      fetchData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        baseFormData: {},
        status: '',
        billStatus: '',
        goodsCategory: '',
        contractTypeList: [], // 合同类别
        contractTitleList: [], //合同类型
        contractPenaltyTypeList: [], //合同违约金类型
        companyList: [],
        departmentList: [],
        companyName: '',
        companyCode: '',
        departmentCode: '',
        departmentName: '',
        contractPenaltyTypeCode: 'FIXED',
        isPenaltyType: false,
      };
    },
    computed: {
      formColumn() {
        return baseFormColumn(this);
      },
      formRules() {
        return baseFormRules(this);
      },
    },
    mounted() {
      console.log(this.userInfo, '当前登陆人信息哦');
      this.status = this.$route.query.status;
      this.contractTypeList = this.dictListMap.serviceContractType;
      this.contractTitleList = this.dictListMap.serviceContractTitleType;
      this.contractPenaltyTypeList = this.dictListMap.liquidatedDamages;
      this._getCompanyApi();
      this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
      console.log(this.contractTypeList, '合同类别列表');
      if (this.status == 'create') {
        this.initData();
      }
    },
    methods: {
      initData() {
        this.companyName = this.userInfo.companyName;
        this.companyCode = this.userInfo.companyCode;
        this.departmentCode = this.userInfo.departmentCode;
        this.departmentName = this.userInfo.departmentName;
        this.baseFormData = {
          companyName: this.userInfo.companyName,
          companyCode: this.userInfo.companyCode,
          applyDepartment: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          departmentCode: this.userInfo.departmentCode,
          isViolationResponsibility: 0,
        };
        console.log(this.baseFormData, '表单信息');
      },
      // 获取表格数据
      async getTableData() {
        return await this.$refs.baseInfoFormRef.getValidateFormData();
      },
      // 获取公司
      async _getCompanyApi() {
        this.loading.startLoading();
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        this.loading.endLoading();
        if (data.code == 0) {
          this.companyList = data.data?.personCompanyInfo;
          console.log(this.companyList, '当前登陆人公司列表');
          // 默认初始化全部表单数据
          if (this.baseFormData.companyCode) {
            // 获取部门下拉
            this._getDepartmentByCompanyCodeApi(this.baseFormData.companyCode);
          }
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode) {
        if (companyCode) {
          const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          });
          if (data.code == 0) {
            this.departmentList = data.data?.personDepartmentInfo.map((item) => {
              return {
                label: item.personDepartmentName,
                value: item.personDepartmentCode,
              };
            });
          } else {
            console.error('获取部门失败');
          }
        }
      },
      changeMethod(row) {
        if (row.prop == 'projectNo') {
          this.baseFormData.projectName = row.val[0].projectName;
          this.baseFormData.projectNo = row.val[0].projectInitiationNo;
        } else if (row.prop == 'supplierName') {
          this.baseFormData.supplierNo = row.val[0].partnerCode;
        } else if (row.prop == 'companyCode') {
          const item = this.companyList.find((item) => item.personCompanyCode == row.val);
          this.baseFormData = {
            ...this.baseFormData,
            departmentCode: '',
            departmentName: '',
            applyDepartment: '',
            supplierNo: '',
            supplierName: '',
            salesmanNo: '',
            salesmanName: '',
            companyCode: row.val,
            companyName: item?.personCompanyName,
            isGenerateSales: false,
          };
          if (row.val) {
            this._getDepartmentByCompanyCodeApi(row.val);
          }
        } else if (row.prop == 'applyDepartment') {
          const item = this.departmentList.find((item) => item.value == row.val);
          this.baseFormData = {
            ...this.baseFormData,
            applyDepartment: row.val,
            departmentCode: row.val,
            departmentName: item?.label,
            supplierNo: '',
            supplierName: '',
          };
        } else if (row.prop == 'supplierNo') {
          this.baseFormData = {
            ...this.baseFormData,
            supplierNo: row.val[0].partnerCode,
            supplierName: row.val[0].partnerZhName,
          };
        } else if (row.prop == 'salesmanNo') {
          this.baseFormData = {
            ...this.baseFormData,
            salesmanNo: row.val[0].id,
            salesmanName: row.val[0].personName,
          };
          console.log(this.baseFormData, '选择的供应商');
        } else if (row.prop == 'contractPenaltyTypeCode') {
          this.baseFormData = {
            ...this.baseFormData,
            penaltyTypeValue: null,
            penaltyDailyRate: null,
            contractPenaltyTypeCode: row.val,
            contractPenaltyTypeName: this.contractPenaltyTypeList.find(
              (item) => item.value == row.val
            )?.label,
          };
          this.contractPenaltyTypeCode = row.val;
          console.log(this.baseFormData, '选择的供应商');
        } else if (row.prop == 'isViolationResponsibility') {
          if (row.val == 1) {
            this.isPenaltyType = true;
            if (
              this.baseFormData.contractPenaltyTypeCode == undefined ||
              this.baseFormData.contractPenaltyTypeCode == null
            ) {
              this.baseFormData.contractPenaltyTypeCode = 'FIXED';
              this.baseFormData.contractPenaltyTypeName = '按固定值';
            }
          } else {
            this.isPenaltyType = false;
          }
        }
      },
    },
    watch: {
      fetchData: {
        handler(val) {
          console.log('val', val);
          if (val && Object.keys(val).length) {
            let newObj = {};
            for (const key in val) {
              if (key == 'projectNo' && val[key] == null) {
                newObj[key] = ' ';
              } else if (key == 'projectName' && val[key] == null) {
                newObj[key] = ' ';
              } else if (key == 'salesmanName' && val[key] == null) {
                newObj[key] = ' ';
              } else if (
                key == 'contractUnitAmount' ||
                key == 'penaltyTypeValue' ||
                key == 'penaltyDailyRate'
              ) {
                if (val[key] == null) {
                  newObj[key] = ' ';
                } else {
                  newObj[key] = String(val[key]);
                }
              } else if (key == 'contractTitle' && val[key] == null) {
                newObj[key] = ' ';
              } else if (key == 'contractPenaltyTypeCode') {
                if (val[key] == null) {
                  newObj[key] = ' ';
                  // return;
                } else {
                  newObj[key] = val[key];
                  this.contractPenaltyTypeCode = val[key];
                }
              } else if (key == 'remark' && val[key] == null) {
                newObj[key] = ' ';
              } else if (
                key == 'contractAmount' ||
                key == 'contractQuantity' ||
                key == 'contractTitle'
              ) {
                newObj[key] = String(val[key]);
              } else if (key == 'isViolationResponsibility') {
                if (val[key] == 1) {
                  this.isPenaltyType = true;
                } else {
                  this.isPenaltyType = false;
                }
                newObj[key] = val[key];
              } else {
                newObj[key] = val[key];
              }
            }
            if (!newObj.operaterName) {
              newObj.operaterName = this.userInfo.userName;
            }
            this.baseFormData = {
              ...newObj,
            };
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
